exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#settings-page[data-v-37a8cbb5] {\n    max-width: 1000px;\n}\n.repurchase-reference-cell input[type=\"checkbox\"][data-v-37a8cbb5] {\n    transform: scale(1.2);\n    cursor: pointer;\n}\n.repurchase-reference-info[data-v-37a8cbb5] {\n    cursor: help;\n    font-size: 0.85em;\n}\n.repurchase-reference-info .tooltip-content[data-v-37a8cbb5] {\n    font-size: 13px;\n    line-height: 1.4;\n    white-space: normal;\n    bottom: auto;\n    top: 100%;\n    margin-top: 10px;\n    margin-bottom: 0;\n}\n.repurchase-reference-info .tooltip-content[data-v-37a8cbb5]::after {\n    bottom: auto;\n    top: -5px;\n}\n", ""]);

// exports
